module.exports = "ng2-map {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    height: 100%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/_payatstore/payatstore.component.css
// module id = ./src/app/sendMoney/_payatstore/payatstore.component.css
// module chunks = main